import { registerSlot } from "../../core/slots.jsx";
import { PhoneShootButton } from "../../pages/phone/PhotoInput.jsx";

/**
 * モジュール field（現場力だけの機能）の画面の並び（#142 段2、docs/52 §2。../eigyouryoku/docs/09 §4.1 と同じ形）。
 *   差し込み口に入れるのは、まとまった部品だけ：スマホの見積の下の帯の「撮る」。
 *   選択肢・欄の1つ（率の基礎の「労務費に対して」・行の「労務費」・何の費用か・材工区分・施主名・写真の印と「写真を見る」・行の「撮る」）は
 *   その場で hasModule／useModule（core/slots.tsx）で出し分ける。門は API の requireModule("field")（写真の道）
 */
export function registerField(): void {
  registerSlot("phone.shoot", "field", PhoneShootButton);
}
